import { getIn } from 'formik';
import { Checkbox as Checkbox$1 } from '@shipengine/giger';
import { jsx } from '@emotion/react/jsx-runtime';

function fieldToCheckbox(_ref) {
  let {
    disabled,
    field: {
      onBlur: fieldOnBlur,
      value,
      onChange: onFormikChange,
      ...field
    },
    form: {
      isSubmitting,
      errors,
      touched
    },
    onBlur,
    onChange,
    ...props
  } = _ref;
  /**
   * Checkbox can be used as a single item and as a part of multiple choices
   * (sharing the "name" attribute) In that case the field value will be an array
   * as multiple inputs have the same name.
   * For all other scenarios "value" will be the input value (string, boolean, number ...)
   */
  const checkboxIsPartOfMultiple = Array.isArray(value);
  const indeterminate = !checkboxIsPartOfMultiple && value == null;
  const handleChange = e => {
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
    onFormikChange(e);
  };
  return {
    isInvalid: getIn(touched, field.name) && !!getIn(errors, field.name),
    disabled: disabled || isSubmitting,
    checked: checkboxIsPartOfMultiple ? value.includes(props.value) : Boolean(value),
    value,
    indeterminate,
    onBlur: onBlur !== null && onBlur !== void 0 ? onBlur : function (e) {
      fieldOnBlur(e !== null && e !== void 0 ? e : field.name);
    },
    onChange: handleChange,
    ...field,
    ...props
  };
}
function Checkbox(props) {
  return jsx(Checkbox$1, {
    ...fieldToCheckbox(props)
  });
}
Checkbox.displayName = 'FormikCheckbox';

export { Checkbox, fieldToCheckbox };
//# sourceMappingURL=Checkbox.js.map
